// src/data/faqData.js

const faqData = {
  rudrakshas: [
    {
      question: "How do I know if a Rudraksha is original?",
      answer:
        "Every genuine Rudraksha has natural mukhis (lines) and unique characteristics. Astro Logical Solutions provides authentic Rudraksha along with quality assurance to help customers purchase with confidence.",
    },
    {
      question: "Which Mukhi Rudraksha is best for me?",
      answer:
        "The ideal Rudraksha depends on your personal goals, birth chart, and life circumstances. Our experts at Astro Logical Solutions can guide you in selecting the most suitable Rudraksha for your needs.",
    },
    {
      question: "Can I wear Rudraksha every day?",
      answer: "Yes. You can wear it daily after proper energization.",
    },
    {
      question: "Can anyone wear Rudraksha?",
      answer:
        "Yes. Men, women, and children can wear Rudraksha regardless of age or profession. Choosing the correct Mukhi is recommended for the best experience.",
    },
    {
      question: "Is it necessary to energize a Rudraksha before wearing it?",
      answer:
        "Yes. Energizing (Pran Pratishtha) is traditionally recommended to enhance the spiritual significance of the Rudraksha before wearing it.",
    },
    {
      question: "How should I take care of my Rudraksha?",
      answer:
        "Keep it clean, avoid harsh chemicals, and apply a small amount of natural oil occasionally to prevent it from drying. Store it in a clean and respectful place when not in use.",
    },
    {
      question: "Why should I buy Rudraksha from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions is committed to providing authentic Rudraksha, expert guidance, quality assurance, and dedicated customer support to help customers choose the right spiritual products.",
    },
  ],
  shivling: [
    {
      question: "What is the significance of a Shivling?",
      answer:
        "The Shivling is a sacred symbol of Lord Shiva and represents divine energy, creation, and spiritual consciousness. Devotees worship the Shivling to seek blessings for peace, prosperity, protection, and spiritual growth.",
    },
    {
      question: "Which Shivling is best for home worship?",
      answer:
        "The ideal Shivling depends on your spiritual practices and preferences. Popular choices include Parad Shivling, Narmadeshwar Shivling, and Crystal Shivling. Astro Logical Solutions offers a variety of authentic Shivlings suitable for home temples and daily worship.",
    },
    {
      question: "How should I worship a Shivling at home?",
      answer:
        "A Shivling can be worshipped by offering clean water, milk, Bilva (Bel) leaves, flowers, and chanting the 'Om Namah Shivaya' mantra with devotion. Regular worship is believed to bring positivity and inner peace.",
    },
    {
      question: "Can anyone keep a Shivling at home?",
      answer:
        "Yes. A Shivling can be kept at home when it is placed respectfully in a clean and sacred space. Regular prayers and proper care are traditionally recommended.",
    },
    {
      question: "Why buy a Shivling from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides carefully selected, authentic Shivlings with expert guidance to help devotees choose the most suitable Shivling for worship, spiritual practices, and gifting.",
    },
  ],
  "shankh-sea-shells": [
    {
      question: "What are Shankh (Sea Shells) used for in Hindu rituals?",
      answer:
        "Shankh (Sea Shells) are considered highly auspicious in Hindu traditions. They are used during daily पूजा (Puja), aarti, and religious ceremonies to invite positive energy, prosperity, and divine blessings into the home.",
    },
    {
      question: "Which Shankh is best for home and पूजा?",
      answer:
        "Popular choices include Dakshinavarti Shankh, Vamavarti Shankh, and Gaumukhi Shankh. The ideal Shankh depends on your spiritual purpose and rituals. Astro Logical Solutions offers authentic Shankh suitable for home temples and devotional use.",
    },
    {
      question: "Can I keep a Shankh at home?",
      answer:
        "Yes. Keeping a sacred Shankh at home is believed to attract positive vibrations, peace, and prosperity. It should be placed in a clean prayer area and handled with respect.",
    },
    {
      question: "How should I care for a Shankh?",
      answer:
        "Clean the Shankh regularly with fresh water, keep it dry after use, and store it in a clean place. Avoid using harsh chemicals to maintain its natural beauty and purity.",
    },
    {
      question: "Why buy Shankh (Sea Shells) from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides carefully selected, authentic Shankh (Sea Shells) with quality assurance and expert guidance, helping you choose the right sacred conch for worship, rituals, and spiritual practices.",
    },
  ],
  shaligram: [
    {
      question: "What is Shaligram and why is it considered sacred?",
      answer:
        "Shaligram is a naturally occurring sacred stone revered as a manifestation of Lord Vishnu. It is worshipped for spiritual growth, peace, prosperity, and divine blessings.",
    },
    {
      question: "How should Shaligram be worshipped?",
      answer:
        "Shaligram should be worshipped with clean water, Tulsi leaves, flowers, and prayers dedicated to Lord Vishnu. Regular worship with devotion is believed to bring harmony and positivity into the home.",
    },
    {
      question: "Can Shaligram be kept at home?",
      answer:
        "Yes. Shaligram can be kept in a clean and sacred place in the home temple. It should be treated with respect and worshipped regularly according to traditional practices.",
    },
    {
      question: "What are the benefits of keeping a Shaligram?",
      answer:
        "According to Hindu tradition, worshipping Shaligram is believed to bring peace, prosperity, spiritual growth, and the blessings of Lord Vishnu while creating a positive atmosphere in the home.",
    },
    {
      question: "Why buy Shaligram from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers carefully selected and authentic Shaligram with expert guidance, helping devotees choose the right sacred stone for worship and spiritual practices.",
    },
  ],
  gemstones: [
    {
      question: "Are the gemstones natural and authentic?",
      answer:
        "Yes. Astro Logical Solutions offers carefully selected natural gemstones. Many gemstones are available with quality assurance and certification to help customers purchase with confidence.",
    },
    {
      question: "How do I know which gemstone is right for me?",
      answer:
        "The ideal gemstone depends on your birth chart, planetary positions, and personal goals. Our astrology experts can guide you in choosing the most suitable gemstone.",
    },
    {
      question: "Should gemstones be energized before wearing?",
      answer:
        "Yes. According to traditional Vedic practices, gemstones are often cleansed and energized before wearing to enhance their spiritual significance and align with the wearer's intentions.",
    },
    {
      question: "How should I care for my gemstone?",
      answer:
        "Clean your gemstone regularly with a soft cloth and mild water, avoid harsh chemicals, and store it safely to maintain its natural beauty and shine.",
    },
    {
      question: "Why buy gemstones from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides authentic gemstones, expert guidance, and quality assurance to help you choose the right gemstone for astrology, jewelry, and spiritual purposes.",
    },
  ],

  crystals: [
    {
      question: "What are Crystals & Healing Stones used for?",
      answer:
        "Crystals and Healing Stones are widely used in spiritual practices, meditation, energy balancing, and home décor. Many people believe they help create a calm, positive, and harmonious environment.",
    },
    {
      question: "How do I choose the right Healing Crystal?",
      answer:
        "The right crystal depends on your intentions and personal goals, such as love, protection, confidence, prosperity, or emotional balance. Astro Logical Solutions can help you choose the most suitable crystal for your needs.",
    },
    {
      question: "Do Healing Crystals need to be cleansed?",
      answer:
        "Yes. It is traditionally recommended to cleanse Healing Crystals regularly using clean water (where suitable), moonlight, incense, or other traditional cleansing methods to maintain their spiritual significance.",
    },
    {
      question: "Can I keep Healing Stones at home or in the office?",
      answer:
        "Yes. Healing Stones can be placed in homes, offices, meditation spaces, or carried personally. Many people use them to promote positive energy and a peaceful atmosphere.",
    },
    {
      question:
        "Why buy Crystals & Healing Stones from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers carefully selected, authentic Crystals and Healing Stones with expert guidance, helping you choose the right crystal for meditation, spiritual practices, and positive energy.",
    },
  ],

  "vastu-products": [
    {
      question: "What are Vastu Shastra Products used for?",
      answer:
        "Vastu Shastra Products are used to support traditional Vastu principles and help create a balanced, peaceful, and positive environment in homes, offices, and workplaces.",
    },
    {
      question: "Which Vastu product is best for my home or office?",
      answer:
        "The ideal Vastu product depends on your property's layout and your specific concerns. Astro Logical Solutions offers expert guidance to help you choose the most suitable Vastu remedies.",
    },
    {
      question: "Where should Vastu products be placed?",
      answer:
        "The placement of Vastu products depends on the type of product and the direction it is intended for. Proper placement is traditionally recommended to achieve the desired Vastu benefits.",
    },
    {
      question: "Can Vastu products help reduce Vastu doshas?",
      answer:
        "According to traditional Vastu beliefs, properly placed Vastu products may help balance energy and reduce the effects of Vastu imbalances in a home or workplace.",
    },
    {
      question: "Why buy Vastu Shastra Products from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides authentic Vastu Shastra Products along with expert guidance to help customers select the right remedies for homes, offices, and commercial spaces.",
    },
  ],

  pooja: [
    {
      question: "What Pooja products are available at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers a wide range of Pooja products, including diyas, incense sticks, camphor, kumkum, roli, kalash, bells, puja thalis, and other essential items for daily worship and religious ceremonies.",
    },
    {
      question: "How do I choose the right Pooja items?",
      answer:
        "The required Pooja items depend on the type of ritual or festival you are performing. Our team can help you select the appropriate products for your spiritual and religious needs.",
    },
    {
      question: "Are your Pooja products suitable for daily worship?",
      answer:
        "Yes. Our Pooja products are carefully selected for daily prayers, temple use, festive celebrations, and special religious ceremonies.",
    },
    {
      question:
        "Can I use these Pooja products for festivals and special occasions?",
      answer:
        "Absolutely. Our Pooja essentials are ideal for festivals such as Diwali, Navratri, Ganesh Chaturthi, Maha Shivratri, Janmashtami, and many other religious occasions.",
    },
    {
      question: "Why buy Pooja products from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides high-quality Pooja essentials with expert guidance, helping devotees find authentic products for daily worship, rituals, and spiritual practices.",
    },
  ],

  tulsi: [
    {
      question: "What are Tulsi, Chandan, and other wood products used for?",
      answer:
        "Tulsi, Chandan, and other sacred wood products are widely used for daily worship, meditation, mantra chanting, and spiritual practices. They are also valued for their traditional and religious significance.",
    },
    {
      question: "What types of Tulsi and Chandan products are available?",
      answer:
        "Astro Logical Solutions offers a variety of sacred products, including Tulsi Kanthi Malas, Tulsi Jap Malas, Chandan Malas, bracelets, beads, and other wooden spiritual accessories.",
    },
    {
      question: "Can Tulsi and Chandan Malas be worn every day?",
      answer:
        "Yes. Tulsi and Chandan Malas are commonly worn daily for prayer, meditation, and devotion. They should be handled with respect and kept clean to maintain their natural quality.",
    },
    {
      question: "How should I care for Tulsi and Chandan products?",
      answer:
        "Keep them away from excessive moisture and harsh chemicals. Clean them gently with a soft, dry cloth and store them in a clean place when not in use.",
    },
    {
      question:
        "Why buy Tulsi, Chandan & Other Wood Products from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions provides carefully selected, authentic Tulsi, Chandan, and other sacred wood products with expert guidance, ensuring quality for worship, meditation, and spiritual practices.",
    },
  ],

perfumes: [
  {
    question: "What types of fragrances and perfume products are available?",
    answer:
      "Astro Logical Solutions offers a wide range of fragrance products, including Traditional Ittar, Solid Perfumes, Non-Alcoholic Fragrance Mists, Room Fresheners, fragrances for men and women, unisex fragrances, and fragrances specially designed for cars.",
  },
  {
    question: "What types of Traditional Ittar are available?",
    answer:
      "Our Traditional Ittar collection includes classic fragrances such as Ruh Gulab, Kewda, Jasmine or Mogra, Sandalwood or Chandan, Mitti Ittar, Shamama, Khus, and Hina. These traditional scents are valued for their rich aromas and timeless appeal.",
  },
  {
    question: "What are Solid Perfumes and how are they used?",
    answer:
      "Solid Perfumes are compact fragrance products that are easy to carry and apply. They can be gently applied to pulse points such as the wrists and neck, making them a convenient choice for everyday fragrance and travel.",
  },
  {
    question: "Are Non-Alcoholic Fragrance Mists suitable for everyday use?",
    answer:
      "Yes. Non-Alcoholic Fragrance Mists are designed as convenient fragrance options for everyday use. They provide a pleasant aroma without relying on traditional alcohol-based perfume formulations and can be used as part of a daily personal fragrance routine.",
  },
  {
    question: "Do you offer fragrances for both men and women?",
    answer:
      "Yes. Astro Logical Solutions offers fragrance options for both men and women, featuring different scent profiles to suit individual preferences. The collection also includes Unisex Fragrances that can be enjoyed by anyone.",
  },
  {
    question: "What are Room Fresheners and Car Fragrances used for?",
    answer:
      "Room Fresheners are designed to add a pleasant fragrance to indoor spaces, while Car Fragrances help maintain a fresh and inviting atmosphere inside vehicles. Both are available in different fragrance profiles to suit personal preferences.",
  },
  {
    question: "Why choose fragrances from Astro Logical Solutions?",
    answer:
      "Astro Logical Solutions offers a diverse fragrance collection covering traditional and modern scent preferences. From authentic-style Ittars and Solid Perfumes to Non-Alcoholic Mists, Room Fresheners, men's and women's fragrances, Unisex Fragrances, and Car Fragrances, customers can explore multiple options in one place.",
  },
],


  "shop-by-concern": [
    {
      question: "What is the Shop by Concern category?",
      answer:
        "The Shop by Concern category helps you find spiritual products based on your specific needs, such as career growth, wealth, health, relationships, protection, peace of mind, and overall well-being.",
    },
    {
      question: "How do I choose the right product for my concern?",
      answer:
        "The ideal product depends on your personal goals and requirements. Astro Logical Solutions provides expert guidance to help you select the most suitable spiritual products for your concern.",
    },
    {
      question: "Can I purchase products for more than one concern?",
      answer:
        "Yes. You can choose products that address multiple concerns, such as prosperity, protection, confidence, and spiritual growth, based on your individual needs.",
    },
    {
      question: "Are the products in this category authentic?",
      answer:
        "Yes. Astro Logical Solutions offers carefully selected and authentic spiritual products to ensure quality, reliability, and customer satisfaction.",
    },
    {
      question: "Why shop by concern at Astro Logical Solutions?",
      answer:
        "Shopping by concern makes it easier to find the most relevant spiritual products for your goals, while our expert guidance helps you make an informed choice with confidence.",
    },
  ],

  "shop-by-astrology": [
    {
      question: "What is the Shop by Astrology category?",
      answer:
        "The Shop by Astrology category helps you explore spiritual products based on your zodiac sign, planetary influences, and traditional Vedic astrology recommendations.",
    },
    {
      question: "How do I choose the right astrology product?",
      answer:
        "The right product depends on your birth chart, planetary positions, and personal goals. Astro Logical Solutions provides expert guidance to help you select the most suitable astrology products.",
    },
    {
      question: "Can I shop according to my zodiac sign?",
      answer:
        "Yes. You can browse products recommended for your zodiac sign to support traditional astrological practices and your personal spiritual journey.",
    },
    {
      question: "Are astrology-based product recommendations accurate?",
      answer:
        "Our recommendations are based on traditional Vedic astrology principles. For personalized guidance, Astro Logical Solutions also offers expert consultation based on your horoscope.",
    },
    {
      question: "Why shop by astrology at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers authentic spiritual products along with expert astrology guidance, making it easier to choose remedies and products suited to your astrological profile.",
    },
  ],

  "shop-by-birth-number": [
    {
      question: "What is the Shop by Birth Number category?",
      answer:
        "The Shop by Birth Number category helps you discover spiritual products based on your Birth Number (Mulank) according to traditional numerology principles.",
    },
    {
      question: "How do I find my Birth Number (Mulank)?",
      answer:
        "Your Birth Number is calculated from the day of the month on which you were born. For example, if you were born on the 15th, your Birth Number is 1 + 5 = 6.",
    },
    {
      question: "What products are recommended according to my Birth Number?",
      answer:
        "Depending on your Birth Number, you may be guided toward specific Rudrakshas, gemstones, malas, Yantras, or other spiritual products traditionally associated with numerology.",
    },
    {
      question: "Can I use Shop by Birth Number without a horoscope?",
      answer:
        "Yes. Birth Number recommendations are based on your date of birth and do not require a complete horoscope, making them a simple way to explore numerology-based products.",
    },
    {
      question: "Why shop by Birth Number at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions combines traditional numerology insights with authentic spiritual products and expert guidance to help you choose remedies that align with your Birth Number.",
    },
  ],
};

export default faqData;
